// Vollbild-Ansicht eines Chat-Bilds mit Herunterladen und In-neuem-Tab-Öffnen.
import { ArrowSquareOut, DownloadSimple, X } from '@phosphor-icons/react';

export function BildGross({ bild, onSchliessen, onHerunterladen }: {
  bild: { url: string; path: string; name: string | null };
  onSchliessen: () => void;
  onHerunterladen: (b: { path: string; name: string | null }) => void;
}) {
  return (
    <div
      className="fixed inset-0 z-[600] flex flex-col bg-black/85"
      onClick={onSchliessen}
    >
      <div
        className="flex items-center gap-2 px-4 py-3 text-white"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="min-w-0 flex-1 truncate text-[13px] text-white/70">{bild.name || 'Bild'}</span>
        <button
          type="button"
          onClick={() => onHerunterladen(bild)}
          title="Bild speichern"
          className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
        >
          <DownloadSimple size={15} weight="bold" />
        </button>
        <button
          type="button"
          onClick={() => window.open(bild.url, '_blank', 'noopener')}
          title="In neuem Tab öffnen"
          className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
        >
          <ArrowSquareOut size={15} weight="bold" />
        </button>
        <button
          type="button"
          onClick={onSchliessen}
          title="Schließen"
          className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
        >
          <X size={15} weight="bold" />
        </button>
      </div>
      <div className="flex min-h-0 flex-1 items-center justify-center p-4 pt-0">
        <img
          src={bild.url}
          alt={bild.name || ''}
          onClick={(e) => e.stopPropagation()}
          className="max-h-full max-w-full rounded-xl object-contain"
        />
      </div>
    </div>
  );
}
